import React, { useEffect } from 'react';
import Backdrop from 'components/Backdrop';
import Button from 'components/Button';
import { IoClose } from "react-icons/io5";

import './index.css';

type PopupProps = {
    title?: string;
    primaryButtonText?: string;
    primaryButtonOnClick?: () => void;
    secondaryButtonText?: string;
    secondaryButtonOnClick?: () => void;
    manageExit?: (event: any) => void;
    indexFilters,
    handleReview: (event: string) => void;
    innerRef?: React.RefObject<HTMLDivElement>;
}

function Popup({
    title,
    primaryButtonText,
    primaryButtonOnClick,
    secondaryButtonText,
    secondaryButtonOnClick,
    manageExit,
    indexFilters,
    handleReview,
    innerRef
}: PopupProps) {

    useEffect(()=>{
        console.log(indexFilters)
    }, [indexFilters])
    return (
        <>
            <Backdrop />
            <div className='popupACT' ref={innerRef}>
                <div className='popupACT__header'>
                    <h1 className='popupACT__title'>{title}</h1>
                    <IoClose className='popupACT__closeIcon' onClick={()=>{manageExit(false)}} />
                </div>
                <div className='popupACT__contentContainer'>
                    <div className='popupACT__content1'>
                        <div>
                            There are <span className='popupACT__contentNumber'>{indexFilters['Unanswered']}</span> unanswered question(s).
                        </div>
                        <div className='popupACT__reviewButton' onClick={()=>handleReview('Unanswered')}>UNANSWERED REVIEW</div>
                    </div>
                    <div className='popupACT__content2'>
                        <div>There are <span className='popupACT__contentNumber'>{indexFilters['Flagged']}</span> question(s) flagged for review.</div>
                        <div className='popupACT__reviewButton2' onClick={()=>handleReview('Flagged')}>FLAGGED REVIEW</div>
                    </div> 
                    <div>Are you sure you want to end the test?</div>
                </div>
                <div className='popupACT__buttonGroup'>
                    {primaryButtonText &&
                        <Button
                            className='popupACT__button'
                            onClick={primaryButtonOnClick}
                            secondary
                        >
                            {primaryButtonText}
                        </Button>
                    }
                    {secondaryButtonOnClick &&
                        <Button
                            className='popupACT__button'
                            onClick={secondaryButtonOnClick}
                        >
                            {secondaryButtonText}
                        </Button>
                    }
                </div>
            </div>
        </>
    );
}

export default Popup;